export default function LastHistoryConfig($transitions, RouterHistoryService) {
    $transitions.onStart({}, (transition) => {
        RouterHistoryService.init(transition.to(), transition.from(), transition.params('from'));
    });
}

LastHistoryConfig.$inject = ['$transitions', 'RouterHistoryService'];
